module.exports = __webpack_public_path__ + "images/emoji/sparkle.627164d3f208e2e499a5.png";